import { combineReducers } from 'redux';
import { defaultDetail, defaultNav, defaultResponse, defaultUser } from '@redux/init-state/detail';
import {
    INIT_LOADING,
    INIT_ERR,
    UPDATE_DETAIL_DATA,
    UPDATE_NAV_DATA,
    FETCH_RES_LOADING,
    FETCH_RES_SUCC,
    FETCH_RES_ERR,
    ADD_RES_DATA,
    FETCH_USER_LOADING,
    FETCH_USER_SUCC,
    FETCH_USER_ERR
} from '@redux/action/detail';

function DetailData(state = defaultDetail, action) {
    switch (action.type) {
        case INIT_LOADING:
            return Object.assign({}, state, {
                loading: true
            });
        case UPDATE_DETAIL_DATA:
            return Object.assign({}, state, action.data, {
                loading: false
            });
        case FETCH_RES_ERR:
            return Object.assign({}, state, {
                loading: false,
                isError: true
            });
        default:
            return state;
    }
}

function ResData(state = defaultResponse, action) {
    switch (action.type) {
        case FETCH_RES_LOADING:
            return Object.assign({}, state, {
                loading: true
            });
        case FETCH_RES_SUCC:
            return Object.assign({}, state, {
                loading: false,
                page: action.data.curPage,
                list: [...state.list, ...(action.data.records || [])],
                isEnd: action.data.maxPage <= action.data.curPage
            });
        case FETCH_RES_ERR:
            return Object.assign({}, state, {
                loading: false,
                isError: true
            });
        case ADD_RES_DATA:
            return Object.assign({}, state, {
                list: [...state.list, action.data]
            });
        default:
            return state;
    }
}

function NavData(state = defaultNav, action) {
    switch (action.type) {
        case UPDATE_NAV_DATA:
            return Object.assign({}, state, action.data);
        default:
            return state;
    }
}

function UserData(state = defaultUser, action) {
    switch (action.type) {
        case FETCH_USER_LOADING:
            return Object.assign({}, state, {
                loading: true
            });
        case FETCH_USER_SUCC:
            return Object.assign({}, state, {
                loading: false,
                page: action.data.page,
                list: [...state.list, ...(action.data.userNickNameList || [])],
                isEnd: action.data.pageEnd
            });
        case FETCH_RES_ERR:
            return Object.assign({}, state, {
                loading: false,
                isError: true
            });
        default:
            return state
    }
}

const reducerApp = combineReducers({
    DetailData,
    NavData,
    ResData,
    UserData
});

export default reducerApp;


// WEBPACK FOOTER //
// ./src/redux/reducer/detail.js